import { networkAction } from "helpers/network/networkAction";

import {
  GET_PAYMENTS,
  GET_PAYMENT_BY_ID,
  DELETE_PAYMENT,
  UPDATE_PAYMENT,
  CREATE_PAYMENT,
  REFUND_PAYMENT,
  GET_PAYMENTS_RECENT,
  GET_PAYMENT_DASHBOARD,
} from "constants/payments";

import * as Api from "api";

export const getPayments = (filters) => async (dispatch) =>
  networkAction(dispatch, GET_PAYMENTS, Api.getPayments, [filters]);

export const getPaymentDashboard = (filters) => async (dispatch) =>
  networkAction(dispatch, GET_PAYMENT_DASHBOARD, Api.getPaymentDashboard, [
    filters,
  ]);

export const getPaymentsRecent = () => async (dispatch) =>
  networkAction(dispatch, GET_PAYMENTS_RECENT, Api.getPaymentsRecent, []);

export const getPaymentById = (id) => async (dispatch) =>
  networkAction(dispatch, GET_PAYMENT_BY_ID, Api.getPaymentById, [id]);

export const deletePayment = (id) => async (dispatch) =>
  networkAction(dispatch, DELETE_PAYMENT, Api.deletePayment, [id]);

export const createPayment = (body) => async (dispatch) =>
  networkAction(dispatch, CREATE_PAYMENT, Api.createPayment, [body]);

export const updatePayment = (id, body) => async (dispatch) =>
  networkAction(dispatch, UPDATE_PAYMENT, Api.updatePayment, [id, body]);

export const refundPayment = (id, body) => async (dispatch) =>
  networkAction(dispatch, REFUND_PAYMENT, Api.refundPayment, [id, body]);
